export const LUCENE_ID = 'lucene';
